import { useQuery } from "@tanstack/react-query";
import lensService from "../../../services/lensService";

// Outside the "lens" key, so a decision refreshing the run does not download and re-read the document again.
const useRunDocument = (identifier: string | undefined, enabled: boolean) =>
    useQuery({
        queryKey: ["lensRunDocument", identifier],
        queryFn: () => lensService.fetchRunDocument(identifier as string),
        enabled: enabled && !!identifier,
        staleTime: Infinity,
    });

export default useRunDocument;
